export enum PaymentListDateFilterKeyList {
  UPDATED_AT_FROM = 'updatedAtFrom',
  UPDATED_AT_TO = 'updatedAtTo',
  CREATED_AT_FROM = 'createdAtFrom',
  CREATED_AT_TO = 'createdAtTo',
}

export type PaymentListFilter = {
  operation?: string[];
  country?: string[];
  currency?: string[];
  transactionStatus?: string[];
  moderationStatus?: string[];
  psp?: string[];
  bpId?: string[];
  paymentSystem?: string[];
  os?: string[];
  updatedAtFrom?: number;
  updatedAtTo?: number;
  createdAtFrom?: number;
  createdAtTo?: number;
  cancelledBy?: string;
  processingType?: string;
  fromAmountEur?: number;
  toAmountEur?: number;
  firstDeposit?: string;
  state?: string;
  email?: string;
  affiliateId?: string;
  username?: string;
  accountHolderName?: string;
  transactionId?: string;
  bpWlTransactionId?: string;
  paymentAccount?: string;
  backOfficeAdminEmail?: string;
}
